import { __assign, __read } from "tslib";
import React from 'react';
import { Box, Popover, makeStyles, createStyles, Divider, useTheme, } from '@material-ui/core';
import clsx from 'clsx';
import { ChevronDownIcon, ChevronUpIcon } from '../../icons/draft';
import { Paper } from '../Paper/Paper';
import { Button } from '../Button/Button';
var useStyles = makeStyles(function (theme) {
    var border = function (_a) {
        var isSelected = _a.isSelected;
        return isSelected ? "2px solid " + theme.palette.primary.main : 'none';
    };
    return createStyles({
        button: __assign(__assign({}, theme.typography.button), { background: theme.palette.common.white, border: border, fontSize: theme.typography.body2.fontSize, textTransform: 'capitalize', color: function (_a) {
                var isSelected = _a.isSelected;
                return isSelected ? theme.palette.primary.main : theme.palette.secondary.main;
            }, 
            // TODO: is there a token for this?
            boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.08)', 
            // TODO: trying to match height of the showroom buttons
            height: 52, borderRadius: '1000px', paddingLeft: theme.spacing(3), paddingRight: theme.spacing(3), transitionDuration: '0s, 0s, 0s', '&:hover': {
                border: border,
                color: theme.palette.primary.main,
                background: theme.palette.common.white,
            } }),
        popover: {
            width: theme.spacing(30),
        },
        paper: {
            // TODO: is there a token for that?
            borderRadius: 12,
        },
    });
});
export var Filter = function (_a) {
    var children = _a.children, label = _a.label, resetButtonLabel = _a.resetButtonLabel, saveButtonLabel = _a.saveButtonLabel, onReset = _a.onReset, onSave = _a.onSave, buttonProps = _a.buttonProps, primaryButtonProps = _a.primaryButtonProps, secondaryButtonProps = _a.secondaryButtonProps, popoverProps = _a.popoverProps, isSelected = _a.isSelected;
    var classes = useStyles({ isSelected: isSelected });
    var theme = useTheme();
    var _b = __read(React.useState(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var buttonRef = React.useRef(null);
    var handlePopoverToggle = function () {
        setIsOpen(!isOpen);
    };
    var handleOnSave = function (e) {
        setIsOpen(false);
        onSave === null || onSave === void 0 ? void 0 : onSave(e);
    };
    var handleOnReset = function (e) {
        setIsOpen(!isOpen);
        onReset === null || onReset === void 0 ? void 0 : onReset(e);
    };
    return (React.createElement(Box, null,
        React.createElement(Button, __assign({ ref: buttonRef, variant: "outlined", onClick: handlePopoverToggle, endIcon: isOpen ? React.createElement(ChevronUpIcon, { size: "xs" }) : React.createElement(ChevronDownIcon, { size: "xs" }) }, buttonProps, { className: clsx(classes.button, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className) }), label),
        React.createElement(Popover, { open: isOpen, anchorEl: buttonRef.current, onClose: handlePopoverToggle, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: -theme.spacing(1),
                horizontal: 'left',
            }, PaperProps: {
                component: Paper,
                className: classes.paper,
            } },
            React.createElement(Box, __assign({ p: 3 }, popoverProps, { className: clsx(classes.popover, popoverProps === null || popoverProps === void 0 ? void 0 : popoverProps.className) }), children),
            React.createElement(Divider, null),
            React.createElement(Box, { display: "flex", py: 1.8, px: 3, alignItems: "center" },
                React.createElement(Box, { flexGrow: 1 }, onReset && (React.createElement(Button, __assign({ variant: "text", onClick: handleOnReset }, secondaryButtonProps), resetButtonLabel || 'Reset'))),
                React.createElement(Box, null,
                    React.createElement(Button, __assign({ variant: "contained", onClick: handleOnSave }, primaryButtonProps), saveButtonLabel || 'Save'))))));
};
//# sourceMappingURL=Filter.js.map